export const ensureError = (error: unknown, message?: string): Error => {
  if (error instanceof Error) {
    return error;
  }
  if (message) {
    return new Error(message);
  }
  return new Error(String(error ?? 'Unknown error'));
};
